import { useRequestURL } from '#imports'

function buildSheerIdURl({
  baseSheerIdUrl,
  bmUserId,
}: {
  baseSheerIdUrl: string
  bmUserId: string
}) {
  const url = new URL(baseSheerIdUrl)
  url.searchParams.append('userid', bmUserId)

  return url.href
}

export function buildMilitaryDiscountUrl({
  authenticated,
  baseSheerIdUrl,
  bmUserId = 'USER_ID',
  locale,
}: {
  baseSheerIdUrl: string
  authenticated: boolean
  bmUserId?: string
  locale: string
}) {
  const baseUrl = useRequestURL().origin
  const sheerIdUrl = buildSheerIdURl({
    baseSheerIdUrl,
    bmUserId,
  })

  if (authenticated) return sheerIdUrl

  try {
    const redirectionUrl = new URL(`${baseUrl}/${locale}/auth/login`)
    redirectionUrl.searchParams.append('next', sheerIdUrl)
    redirectionUrl.searchParams.append('type', 'external')
    redirectionUrl.searchParams.append('bm_journey', 'military_discount')

    return redirectionUrl.href
  } catch (err) {
    const invalidUrlError = new Error(
      `"${baseUrl}/${locale}/auth/login" is an invalid URL.`,
    )
    if (err instanceof Error) invalidUrlError.stack = err.stack
    throw invalidUrlError
  }
}
